(function() {
  function Rink() {
    this.init = init;

    function init() {
      initializeMap();
    }

    function initializeMap() {
      var address = $('address').text(),
          mapEl = document.getElementById('map'),
          map,
          geocoder,
          mapOptions = {
              zoom: 15,
              mapTypeId: google.maps.MapTypeId.ROADMAP
          };

      map = new google.maps.Map(mapEl, mapOptions);
      geocoder = new google.maps.Geocoder();

      geocoder.geocode({ 'address': address }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          map.setCenter(results[0].geometry.location);
          var marker = new google.maps.Marker({
              map: map,
              position: results[0].geometry.location
          });
        } else {
          console.log('Geocode was not successful for the following reason: ' + status);
        }
      });
    }
  }
  TSk.Rink = Rink;
})();

$(function() {
  var rink = new TSk.Rink();
  rink.init();
});
